import React from 'react';
import DiscussionPoint from './teasers/DiscussionPoint';
import Quote from './teasers/Quote';
import AudioClip from './teasers/AudioClip';
import SlideshowTeaser from './teasers/SlideshowTeaser';
import VideoTeaser from './teasers/VideoTeaser';
import PressPlayTeaser from './teasers/PressPlayTeaser';

import styles from './teaser.module.scss';

const setTeaserByType = props => {
  switch (props.detail_type) {
    case 'discussion_point':
      return <DiscussionPoint {...props} />;
    case 'quote':
      return <Quote {...props} />;
    case 'slideshow':
      return <SlideshowTeaser {...props} />;
    case 'audio':
      return <AudioClip {...props} />;
    case 'video':
      return (
        <PressPlayTeaser
          {...props}
          label={props.body}
          imageSrc={props.poster.sizes.medium_large}
          alt={props.poster.alt}
        />
      );
    case 'press_and_hold':
      return (
        <PressPlayTeaser
          {...props}
          imageSrc={props.image.sizes.large}
          alt={props.image.alt}
        />
      );
    default:
      return null;
  }
};

const Teaser = props => (
  <div className={styles.container}>{setTeaserByType(props)}</div>
);

export default Teaser;



// WEBPACK FOOTER //
// ./src/components/tour/details/Teaser.js